import React from "react";
import { InsightsTable, InsightsTableRow } from "./InsightsTable";
import { createAggregateRows, createInfluencerRows } from "./utils";
import { GalleryListElement } from "src/app/components/Gallery/components/GalleryItem/GalleryItem";

import "./InsightsDashboardTop.scss";

export interface TopPost {
  social_url: string;
  thumbUrl: string;
  social_provider: string;
  social_media_id: string;
  data: {
    engagementRate: number;
    statistics: {
      count_engagement?: number;
    };
  };
}

export interface TopInfluencer {
  key: string;
  social_username: string;
  social_url: string;
  posts_count: number;
  avg_er: number;
  profile_picture_url?: string | null;
}

export interface AggregateItem {
  key: string;
  posts_count: number;
  avg_er: number;
  profile_picture_url?: string | null;
}

export interface IDTop {
  postsByDate: GalleryListElement[];
  postsByEr: GalleryListElement[];

  influencersByAvgEr: TopInfluencer[];
  influencersByPostCount: TopInfluencer[];

  hashtagsByCount: AggregateItem[];
  hashtagsByAvgEr: AggregateItem[];

  mentionsByCount: AggregateItem[];
  mentionsByAvgEr: AggregateItem[];
}

interface Props {
  data: IDTop;
}

interface TableConfig {
  title: string;
  firstColumnLabel: string;
  data: { er: InsightsTableRow[]; posts: InsightsTableRow[] };
  emptyState: {
    title: string;
    description: string;
  };
}

export const InsightsDashboardTop: React.FC<Props> = ({ data }) => {
  const sections: TableConfig[] = [
    {
      title: "Creators",
      firstColumnLabel: "Creator",
      data: {
        er: createInfluencerRows(data.influencersByAvgEr),
        posts: createInfluencerRows(data.influencersByPostCount),
      },
      emptyState: {
        title: "No creators stand out yet",
        description:
          "We only show creators with at least 10 posts matching your search, and none reached that threshold. Try a broader search or a longer date range.",
      },
    },
    {
      title: "Hashtags",
      firstColumnLabel: "Hashtag",
      data: {
        er: createAggregateRows(data.hashtagsByAvgEr, "#"),
        posts: createAggregateRows(data.hashtagsByCount, "#"),
      },
      emptyState: {
        title: "No recurring hashtags yet",
        description:
          "Hashtags appear here once they show up in at least 10 posts. Try a broader search or a longer date range.",
      },
    },
    {
      title: "Mentions",
      firstColumnLabel: "Mention",
      data: {
        er: createAggregateRows(data.mentionsByAvgEr, "@"),
        posts: createAggregateRows(data.mentionsByCount, "@"),
      },
      emptyState: {
        title: "No recurring mentions yet",
        description:
          "Mentions appear here once they show up in at least 10 posts. Try a broader search or a longer date range.",
      },
    },
  ];

  return (
    <div className="id-top-insights">
      <div className="id-top-insights__grid">
        <div className="id-top-insights__grid-row id-top-insights__grid-row--first">
          {sections?.map((section) => (
            <InsightsTable
              key={section.title}
              title={section.title}
              firstColumnLabel={section.firstColumnLabel}
              data={section.data}
              emptyState={section.emptyState}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
